import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=391a6442&scoped=true"
import script from "./vipDetail.vue?vue&type=script&lang=js"
export * from "./vipDetail.vue?vue&type=script&lang=js"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=391a6442&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a6442",
  null
  
)

export default component.exports